export default __webpack_public_path__ + "static/media/nuvoton.6a279cd9.webp";